import React, {useMemo} from 'react'
import {Button} from "../../../ui-components";
import {InfoTooltipTrigger, PanelFooter} from "../../../shared";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {
  changeCustomerErCallStatus,
  changeDestinationDestinationStatusCustomer,
  changeDestinationStatusCustomer, customerEndErCallFromHospitalizationFrom
} from "../../requests/er-thunk";
// import CustomerDpInfo from "../CustomerDpInfo";
import BrigadeInfo from "../../brigade/brigadeInfo";
import {RouteIcon} from "../../../assets";
import DpDestinations from "../../scheduledCall/DpScheduledComponents/DpDestinations"
import DpScheduledPatientInfo from "../../scheduledCall/DpScheduledComponents/DpScheduledPatientInfo"
import CustomerDpInfo from "../../sentry/CustomerDpInfo";
import HospitalizationBrigadeInfo from "../../sentry/DpComponents/HospitalizationBrigadeInfo";
import DpDcActionsPopover from "../../sentry/DpComponents/DpDcActionsPopover";
import CustomerActionsTooltip from "../../sentry/DpComponents/customerActionsTooltip";
import {ER_CALL_STATUSES} from "../../../services/constants";
import PayInfoDp from "../../sentry/DpComponents/PayInfoDp";


const ScheduledStart = () => {
  const {er_call, request, payment} = useAppSelector(state => state.requests)
  const dispatch = useAppDispatch()
  const selectedRequestBrigade = useMemo(() => {
    if (request) {
      return request?.requestedBrigades?.filter((b) => b.request_uuid === request?.uuid)
    }
  }, [request])
  return (
    <div id='on-way-request' className={`request-info-container ${er_call.status < 13 || er_call.status === 21 ? 'pb-80' : ''}`}>
      <PayInfoDp/>
      <HospitalizationBrigadeInfo/>
      <CustomerDpInfo/>
       <DpScheduledPatientInfo br={request}/>
     <div>
        <div style={{display: "flex", marginTop: 6, alignItems: "center"}}>
          <RouteIcon  className='mr-5'/>
          <div style={{    fontFamily: "Manrope Semibold",
            color: "rgb(25, 34, 51)",
            fontSize: 16,
            fontWeight: 700,
            overflowWrap: "break-word"}}>Пункт назначения</div>
        </div>
        <>
          {request.destination.map((d, index) => {
            return <DpDestinations d={d} index={index}/>
          })}
        </>
      </div>
      {er_call.status === 4 &&
        <>
          <PanelFooter className='footer'>
            {request?.activeTransportation?.status === 1 &&
              <Button disabled={payment.type ===1 &&(payment.status === 8 || payment.status ===9)} type='contained' fullWidth
                     onClick={() => dispatch(changeDestinationStatusCustomer({key: request?.activeTransportation?.key}))}>В пути к пункту назначения {request?.activeTransportation?.key}</Button>}
            {request?.activeTransportation?.status === 2 &&
              <Button type='contained' fullWidth
                      onClick={() => dispatch(changeDestinationStatusCustomer({key: request?.activeTransportation?.key}))}>Прибыл в пункт назначения {request?.activeTransportation?.key}</Button>}
            {request?.activeTransportation?.status === 3 &&
              <Button type='contained' fullWidth
                      onClick={() => dispatch(changeDestinationStatusCustomer({key: request?.activeTransportation?.key, status: ER_CALL_STATUSES.ended}))}>Завершить транспортировку</Button>}
            <InfoTooltipTrigger dataFor={'actions-menu-customer'} className='ml-15'/>
          </PanelFooter>
          {er_call && er_call.status > 1 &&
            // @ts-ignore
            <CustomerActionsTooltip isDp id='actions-menu-customer' offsetLeft={150} offsetTop={-20}/>}
        </>}
      {/*{er_call.status === 21 &&*/}
      {/*  <PanelFooter>*/}
      {/*    <Button type='contained' onClick={() => dispatch(changeCustomerErCallStatus(23))} fullWidth>Начать транспортировку</Button>*/}
      {/*  </PanelFooter>*/}
      {/*}*/}
      <DpDcActionsPopover/>
    </div>
  )
}

export default ScheduledStart
